import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import bakingCcpService from '../services/bakingCcpService';

// Ported verbatim from the old Navbar.js (lines 212-222, 244-261): the QA review
// queue's pending-count badge, refetched on route change and on the
// productionStatusChanged event (dispatched when a baking run completes/stops).
export default function useQaReviewQueue(canReviewQA) {
  const location = useLocation();
  const [pendingQACount, setPendingQACount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const fetchPendingQA = async () => {
      if (!canReviewQA) {
        setPendingQACount(0);
        return;
      }
      try {
        const res = await bakingCcpService.getRuns('COMPLETED');
        const count = Array.isArray(res?.runs) ? res.runs.length : 0;
        if (!cancelled) setPendingQACount(count);
      } catch (e) {
        if (!cancelled) setPendingQACount(0);
      }
    };
    fetchPendingQA();
    return () => { cancelled = true; };
  }, [canReviewQA, location.pathname]);

  useEffect(() => {
    const handler = () => {
      if (!canReviewQA) return;
      bakingCcpService.getRuns('COMPLETED')
        .then(res => setPendingQACount(Array.isArray(res?.runs) ? res.runs.length : 0))
        .catch(() => setPendingQACount(0));
    };
    window.addEventListener('productionStatusChanged', handler);
    return () => window.removeEventListener('productionStatusChanged', handler);
  }, [canReviewQA]);

  return { pendingQACount };
}
